import { z } from "zod";

import { CustomColumnTypes, ListSourceType } from "@/enum/list.enum";
import { MetaDataSchema } from "@/schemas/meta-data";

import { UserSchema } from "../../Apollo/schema/get-people";

export const ColumnTemplateSchema = z.object({
	id: z.number().optional(),
	name: z.string(),
	config: z.any(),
	listSourceType: z.nativeEnum(ListSourceType).optional(),
	initialListId: z.number().optional(),
	initialTrackerId: z.number().optional(),
	type: z.nativeEnum(CustomColumnTypes),
	companyId: z.number().optional(),
	createdBy: UserSchema.optional(),
	updatedBy: UserSchema.optional(),
	createdAt: z.string().optional(),
	updatedAt: z.string().optional(),
});

export const CreateColumnTemplateSchema = z.object({
	id: z.number().optional(),
	name: z.string(),
	config: z.any(),
	initialListId: z.number().optional(),
	listSourceType: z.nativeEnum(ListSourceType).optional(),
	initialTrackerId: z.number().optional(),
	type: z.nativeEnum(CustomColumnTypes),
	generalTemplate: z.boolean(),
});

export const UpdateColumnTemplateSchema = z.object({
	id: z.number(),
	name: z.string(),
	config: z.any(),
	initialListId: z.number().optional(),
	initialTrackerId: z.number().optional(),
	type: z.nativeEnum(CustomColumnTypes),
});

export const ColumnTemplateResponseSchema = z.object({
	data: z.array(ColumnTemplateSchema),
	meta: MetaDataSchema,
});

export type ColumnTemplate = z.infer<typeof ColumnTemplateSchema>;

export type CreateColumnTemplate = z.infer<typeof CreateColumnTemplateSchema>;

export type UpdateColumnTemplate = z.infer<typeof UpdateColumnTemplateSchema>;

export type ColumnTemplateResponse = z.infer<typeof ColumnTemplateResponseSchema>;
